var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.034 8.388l1.527 1.54-.024.023-1.43 1.447c-.15.15-.147.4.004.553a.386.386 0 00.548.005l1.43-1.447c.008-.007.015-.017.022-.024l.484.49c.457.463.568 1.1.12 1.557l-1.122 1.132a1.156 1.156 0 01-1.645-.015l-2.56-2.586zm-1.9-3.818l2.297 2.297-5.99 5.988a1.323 1.323 0 01-.567.334l-2.44.702c-.197.056-.223.188-.368.043-.145-.145-.013-.17.043-.368l.702-2.44a1.31 1.31 0 01.334-.568l5.99-5.988zM5.026 2.35l.489.49-.024.022-1.553 1.552c-.15.15-.148.4.005.553a.393.393 0 00.553.005L6.049 3.42l.02-.025 1.543 1.542-2.675 2.675L2.35 5.024a1.178 1.178 0 01-.015-1.662l1.028-1.026a1.178 1.178 0 011.662.015zm8.277.062l.285.283c.585.585.53 1.482-.057 2.07L12.206 6.09 9.909 3.795l1.325-1.326c.587-.587 1.484-.642 2.069-.057z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.0d3f9e680c6c43cca9a473183dc0f1dc.svg";
export { ForwardRef as ReactComponent };